import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import Login from '@/pages/login/'
// 天猫系路由
import taoRouter from './tao.js'
// 京东系路由
import jdRouter from './jd.js'
Vue.use(Router)
/**
 *
 * hidden:true  如果设为true,菜单项不显示在页面上
 * parent:true  如果设为true,一级菜单项不显示在页面上
 * meta:{
 *   title:'',  菜单显示的名称,
 *   hasChildrenMenu:true,   如果设为true,表示有子菜单(新增,编辑不计入)
 *   activeMenu:'',  如果设置路径,左侧导航高亮,默认$route.path
 * }
 */




//无权限路由
export const constantRoutes = [
  {
    path: '/login',
    component: Login,
    hidden: true,
    meta: {title: '登录'},
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
  },

]

export const systemRoutes = [
    {
        path: '/system',
        name: 'system',
        parent: true,
        component: () => import('@/layout/'),
        meta: {
            title: '系统设置',
            hasChildrenMenu: true
        },
        children: [
            {
                path: 'management',
                name: 'management',
                component: () => import('@/layout/catchContent/'),
                meta: {
                    title: '系统管理',
                    icon: 'iconxitongguanli',
                    hasChildrenMenu: true,
                },
                children: [
                    {
                        path: 'menuAdmin',
                        name: 'menuAdmin',
                        component: () => import('@/pages/system/management/menuAdmin'),
                        meta: {title: '菜单管理'},
                    },
                    {
                        path: 'userAdmin',
                        name: 'userAdmin',
                        component: () => import('@/pages/system/management/userAdmin'),
                        meta: {title: '用户管理'},
                    },
                    {
                        path: 'roleAdmin',
                        name: 'roleAdmin',
                        component: () => import('@/pages/system/management/roleAdmin'),
                        meta: {title: '角色管理'},
                    },
                    {
                      path: 'storeAdmin',
                      name: 'storeAdmin',
                      component: () => import('@/pages/system/management/storeAdmin'),
                      meta: {title: '店铺管理'},
                    },
                    // {
                    //     path: 'warningLog',
                    //     name: 'warningLog',
                    //     component: () => import('@/pages/system/management/warningLog/index.vue'),
                    //     meta: {title: '预警监控'},
                    // }
                ]
            },
        ]
    }
]

export const asyncRoutes = taoRouter.concat(jdRouter)

export const notFound = [
  {
    path: '/404',
    hidden: true,
    component: () => import('@/pages/error/404'),
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]

export const baseRouter = '/ibaiqiu-paid-web'


// 路由重复点击跳转报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const createRouter = () => new Router({
  mode: 'history',
  routes: constantRoutes,
  fallback: true,
  base: baseRouter,
})

// 切换账号时对路由表初始化
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

const router = createRouter()
export default router




// WEBPACK FOOTER //
// ./src/router/index.js